// RBAC presets & labels — mirrors backend/rbac.py

export const ROLE_PRESETS = [
  { key: "admin", label: "Admin", desc: "Full access to everything in the workspace." },
  { key: "team_lead", label: "Team Lead / Manager", desc: "Sees all leads, manages the team & reports. No billing." },
  { key: "senior_counsellor", label: "Senior Counsellor", desc: "Own + claimable leads, can close, refer & view reports." },
  { key: "counsellor", label: "Counsellor", desc: "Own assigned leads. Log, message & move stages." },
  { key: "telecaller", label: "Telecaller / Pre-sales", desc: "Fresh/unassigned leads to qualify. No closing." },
  { key: "viewer", label: "Viewer / Auditor", desc: "Read-only across reports & leads." },
  { key: "custom", label: "Custom role", desc: "Pick exact permissions yourself." },
];

export const LEAD_SCOPES = [
  { key: "all", label: "All leads in workspace" },
  { key: "team", label: "Team's leads" },
  { key: "own", label: "Only leads assigned to them" },
  { key: "unassigned", label: "Only unassigned / fresh leads" },
  { key: "pipeline", label: "Restricted to one pipeline" },
];

export const PERMISSIONS = [
  { key: "create_leads", label: "Create / import leads" },
  { key: "edit_leads", label: "Edit lead details" },
  { key: "change_stage", label: "Change stage / status" },
  { key: "close_leads", label: "Close leads (with reason)" },
  { key: "refer_transfer", label: "Refer / transfer leads" },
  { key: "claim_release", label: "Claim / release leads" },
  { key: "send_whatsapp", label: "Send WhatsApp messages" },
  { key: "manage_templates", label: "Manage WhatsApp templates & automation" },
  { key: "view_analytics", label: "View analytics & scoreboard" },
  { key: "export_csv", label: "Export CSV" },
  { key: "manage_team", label: "Manage team members" },
  { key: "manage_billing", label: "Manage billing & integrations" },
];

export const PRESET_DEFAULTS = {
  admin: { scope: "all", perms: PERMISSIONS.map((p) => p.key) },
  team_lead: { scope: "team", perms: PERMISSIONS.map((p) => p.key).filter((p) => p !== "manage_billing") },
  senior_counsellor: { scope: "own", perms: ["create_leads", "edit_leads", "change_stage", "close_leads", "refer_transfer", "claim_release", "send_whatsapp", "view_analytics"] },
  counsellor: { scope: "own", perms: ["edit_leads", "change_stage", "send_whatsapp", "claim_release"] },
  telecaller: { scope: "unassigned", perms: ["edit_leads", "change_stage", "send_whatsapp"] },
  viewer: { scope: "all", perms: ["view_analytics"] },
  custom: { scope: "own", perms: [] },
};

export function roleLabel(key) {
  return (ROLE_PRESETS.find((r) => r.key === key) || {}).label || key;
}

// Frontend permission gate helper. user.permissions may be ["*"] for admins.
export function can(user, perm) {
  const p = user?.permissions;
  if (!p) return user?.role === "admin" || user?.role === "super_admin";
  return p.includes("*") || p.includes(perm);
}
